import Button from 'tailwind-components/Button/Button';
import React from 'react';
import propTypes from 'prop-types';
import style from './formWithEditButton.module.scss';
import { Pencil } from 'lucide-react';

function FormWithEditButton({ children, className, onClick }) {
  return (
    <div className={className}>
      <Button
        size='medium'
        variant='primary'
        text='Edit'
        className={style.editButton}
        onClick={onClick}
        icon={<Pencil size={20} />}
      />
      {children}
    </div>
  );
}

FormWithEditButton.propTypes = {
  children: propTypes.element,
  onClick: propTypes.func,
  className: propTypes.string
};

export default FormWithEditButton;
